import { useEffect, useState } from 'react';
import dayjs, { type Dayjs } from '@/config/dayjs';

/**
 * Today, at the start of the day, that moves on at midnight. For dates that
 * count from today -- such as presets ending yesterday -- on a page left open
 * overnight, which would otherwise keep the day the page was opened on.
 */
export function useToday(): Dayjs {
  const [today, setToday] = useState(() => dayjs().startOf('day'));

  useEffect(() => {
    const untilTomorrow = today.add(1, 'day').diff(dayjs());
    const timer = setTimeout(
      () => {
        setToday(dayjs().startOf('day'));
      },
      Math.max(untilTomorrow, 0) + 1000,
    );
    return () => {
      clearTimeout(timer);
    };
  }, [today]);

  return today;
}
